'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp, _dec2, _class3, _class4, _temp2, _dec3, _class5, _class6, _temp3, _dec4, _class7, _class8, _temp4, _dec5, _class9, _class10, _temp5, _dec6, _class11, _class12, _temp6;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactTooltip = require('react-tooltip');

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _convert = require('../../helpers/convert');

var _convert2 = _interopRequireDefault(_convert);

var _components = require('../../components');

var _IyvListTable = require('./IyvListTable.css');

var _IyvListTable2 = _interopRequireDefault(_IyvListTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IyvListTable = (_dec = (0, _reactCssModules2.default)(_IyvListTable2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(IyvListTable, _Component);

  //
  function IyvListTable(props) {
    (0, _classCallCheck3.default)(this, IyvListTable);
    return (0, _possibleConstructorReturn3.default)(this, (IyvListTable.__proto__ || (0, _getPrototypeOf2.default)(IyvListTable)).call(this, props));
  }
  //


  (0, _createClass3.default)(IyvListTable, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return (this.props.viewPanel === 'results' || this.props.viewPanel === 'performance' || this.props.viewPanel === 'iyv') && this.props.funds.length > 0 ? _react2.default.createElement(
        'table',
        { styleName: 'table' },
        _react2.default.createElement(
          'thead',
          null,
          _react2.default.createElement(
            'tr',
            { styleName: 'header' },
            /* select is not visible on mobile */
            this.props.selectVisible ? _react2.default.createElement(IyvListThDefault, {
              label: 'Compare',
              prop: '',
              clickColumnHeader: this.props.clickColumnHeader,
              sort: this.props.sort,
              isDesc: this.props.isDesc
            }) : null,
            /* for each column: this.renderTh() */
            this.props.resultsTableColumns[_config2.default.app.title][this.props.viewPanel].map(function (column, i) {
              var label = column[0];
              var prop = column[1];
              if (_config2.default.app.title === 'Gender Equality Funds' && prop === 'gef_grp_norm') {
                switch (_this2.props.activeGrouping) {
                  case 'peer':
                    label = 'Gender equality rank, by category';
                    prop = 'gef_peer_norm';
                    break;
                  case 'rank':
                    label = 'Gender equality rank, all funds';
                    prop = 'gef_rank';
                    break;
                  default:
                    break;
                }
              }
              return _react2.default.createElement(IyvListThDefault, {
                key: 'th-default-' + i,
                label: label,
                prop: prop,
                clickable: true,
                clickColumnHeader: _this2.props.clickColumnHeader,
                sort: _this2.props.sort,
                isDesc: _this2.props.isDesc
              });
            })
          )
        ),
        _react2.default.createElement(IyvListTbody, {
          funds: this.props.funds,
          viewPanel: this.props.viewPanel,
          activeGrouping: this.props.activeGrouping,
          clickShareclass: this.props.clickShareclass,
          clickCompareSelect: this.props.clickCompareSelect,
          selectVisible: this.props.selectVisible,
          cart: this.props.cart,
          resultsTableColumns: this.props.resultsTableColumns,
          getCompareSelectStyles: this.props.getCompareSelectStyles
        })
      ) : null;
    }
  }]);
  return IyvListTable;
}(_react.Component), _class2.propTypes = {
  viewPanel: _react.PropTypes.string,
  funds: _react.PropTypes.array,
  selectVisible: _react.PropTypes.bool,
  sort: _react.PropTypes.string,
  isDesc: _react.PropTypes.bool,
  clickShareclass: _react.PropTypes.func,
  clickCompareSelect: _react.PropTypes.func,
  clickColumnHeader: _react.PropTypes.func,
  activeGrouping: _react.PropTypes.string,
  cart: _react.PropTypes.object,
  getCompareSelectStyles: _react.PropTypes.func,
  resultsTableColumns: _react.PropTypes.object
}, _temp)) || _class);
exports.default = IyvListTable;
var IyvListThDefault = (_dec2 = (0, _reactCssModules2.default)(_IyvListTable2.default, { allowMultiple: true }), _dec2(_class3 = (_temp2 = _class4 = function (_Component2) {
  (0, _inherits3.default)(IyvListThDefault, _Component2);

  //
  function IyvListThDefault(props) {
    (0, _classCallCheck3.default)(this, IyvListThDefault);
    return (0, _possibleConstructorReturn3.default)(this, (IyvListThDefault.__proto__ || (0, _getPrototypeOf2.default)(IyvListThDefault)).call(this, props));
  }
  //


  (0, _createClass3.default)(IyvListThDefault, [{
    key: 'render',
    value: function render() {
      var activeStyle = this.props.prop === this.props.sort ? 'col-active' : '';
      var activeClass = this.props.prop !== this.props.sort ? '' : this.props.isDesc ? 'fa fa-angle-up' : 'fa fa-angle-down';

      if (this.props.clickable) {
        return _react2.default.createElement(
          'th',
          {
            styleName: 'hd-col',
            onClick: this.props.clickColumnHeader(this.props.prop)
          },
          _react2.default.createElement('i', {
            styleName: activeStyle,
            className: activeClass
          }),
          _react2.default.createElement(
            'span',
            null,
            this.props.label
          )
        );
      } else {
        return _react2.default.createElement(
          'th',
          { styleName: 'hd-col-no-hover' },
          _react2.default.createElement(
            'span',
            null,
            this.props.label
          )
        );
      }
    }
  }]);
  return IyvListThDefault;
}(_react.Component), _class4.propTypes = {
  sort: _react.PropTypes.string.isRequired,
  label: _react.PropTypes.string.isRequired,
  prop: _react.PropTypes.string.isRequired,
  clickable: _react.PropTypes.bool,
  isDesc: _react.PropTypes.bool,
  clickColumnHeader: _react.PropTypes.func.isRequired
}, _temp2)) || _class3);
var IyvListTbody = (_dec3 = (0, _reactCssModules2.default)(_IyvListTable2.default, { allowMultiple: true }), _dec3(_class5 = (_temp3 = _class6 = function (_Component3) {
  (0, _inherits3.default)(IyvListTbody, _Component3);

  //
  function IyvListTbody(props) {
    (0, _classCallCheck3.default)(this, IyvListTbody);
    return (0, _possibleConstructorReturn3.default)(this, (IyvListTbody.__proto__ || (0, _getPrototypeOf2.default)(IyvListTbody)).call(this, props));
  }
  //


  (0, _createClass3.default)(IyvListTbody, [{
    key: 'render',
    value: function render() {
      var _this5 = this;

      // error handling - if there are no shareclasses in the list, return null
      if (!this.props.funds || this.props.funds.length === 0) {
        return null;
      }

      return _react2.default.createElement(
        'tbody',
        null,
        this.props.funds.map(function (shareclass, idx) {
          // if a view panel is active
          if (_this5.props.viewPanel === 'results' || _this5.props.viewPanel === 'performance' || _this5.props.viewPanel === 'iyv') {
            return _react2.default.createElement(IyvListTbodyTr, {
              key: 'iyv-tbody-tr-' + idx,
              shareclass: shareclass,
              clickShareclass: _this5.props.clickShareclass,
              clickCompareSelect: _this5.props.clickCompareSelect,
              idx: idx,
              activeGrouping: _this5.props.activeGrouping,
              viewPanel: _this5.props.viewPanel,
              selectVisible: _this5.props.selectVisible,
              cart: _this5.props.cart,
              resultsTableColumns: _this5.props.resultsTableColumns,
              getCompareSelectStyles: _this5.props.getCompareSelectStyles
            });
          }
          return null;
        })
      );
    }
  }]);
  return IyvListTbody;
}(_react.Component), _class6.propTypes = {
  funds: _react.PropTypes.array,
  viewPanel: _react.PropTypes.string,
  activeGrouping: _react.PropTypes.string,
  clickShareclass: _react.PropTypes.func,
  clickCompareSelect: _react.PropTypes.func,
  selectVisible: _react.PropTypes.bool,
  cart: _react.PropTypes.object,
  resultsTableColumns: _react.PropTypes.object,
  getCompareSelectStyles: _react.PropTypes.func
}, _temp3)) || _class5);
var IyvListTbodyTr = (_dec4 = (0, _reactCssModules2.default)(_IyvListTable2.default, { allowMultiple: true }), _dec4(_class7 = (_temp4 = _class8 = function (_Component4) {
  (0, _inherits3.default)(IyvListTbodyTr, _Component4);

  //
  function IyvListTbodyTr(props) {
    (0, _classCallCheck3.default)(this, IyvListTbodyTr);
    return (0, _possibleConstructorReturn3.default)(this, (IyvListTbodyTr.__proto__ || (0, _getPrototypeOf2.default)(IyvListTbodyTr)).call(this, props));
  }
  //


  (0, _createClass3.default)(IyvListTbodyTr, [{
    key: 'render',
    value: function render() {
      var _this7 = this;

      // (shareclass, idx, selectVisible=false)
      return _react2.default.createElement(
        'tr',
        { key: this.props.idx, styleName: 'row-fund' },
        /* render the select box to add/remove shareclasses from the
          cart. select is not visible on mobile */
        this.props.selectVisible ? _react2.default.createElement(IyvListTdCompareSelect, {
          shareclass: this.props.shareclass,
          clickCompareSelect: this.props.clickCompareSelect,
          cart: this.props.cart,
          getCompareSelectStyles: this.props.getCompareSelectStyles
        }) : null,
        /* for each column: this.renderTdByFieldname() */
        this.props.resultsTableColumns[_config2.default.app.title][this.props.viewPanel].map(function (column, _idx) {
          return _react2.default.createElement(IyvListTd, {
            key: 'iyv-td-' + _this7.props.idx + '-' + _idx,
            shareclass: _this7.props.shareclass,
            clickShareclass: _this7.props.clickShareclass,
            fieldName: column[1],
            activeGrouping: _this7.props.activeGrouping
          });
        })
      );
    }
  }]);
  return IyvListTbodyTr;
}(_react.Component), _class8.propTypes = {
  shareclass: _react.PropTypes.object.isRequired,
  clickShareclass: _react.PropTypes.func.isRequired,
  clickCompareSelect: _react.PropTypes.func.isRequired,
  idx: _react.PropTypes.number.isRequired,
  activeGrouping: _react.PropTypes.string,
  viewPanel: _react.PropTypes.string, // isRequired
  selectVisible: _react.PropTypes.bool,
  cart: _react.PropTypes.object,
  resultsTableColumns: _react.PropTypes.object,
  getCompareSelectStyles: _react.PropTypes.func
}, _temp4)) || _class7);
var IyvListTd = (_dec5 = (0, _reactCssModules2.default)(_IyvListTable2.default, { allowMultiple: true }), _dec5(_class9 = (_temp5 = _class10 = function (_Component5) {
  (0, _inherits3.default)(IyvListTd, _Component5);

  //
  function IyvListTd(props) {
    (0, _classCallCheck3.default)(this, IyvListTd);
    return (0, _possibleConstructorReturn3.default)(this, (IyvListTd.__proto__ || (0, _getPrototypeOf2.default)(IyvListTd)).call(this, props));
  }
  //


  (0, _createClass3.default)(IyvListTd, [{
    key: 'render',
    value: function render() {
      /**
       * Different logic based for different fieldnames
       * e.g. one render if it's the shareclass name; another if it's the gun
       * grade; etc.
       */
      if (['name'].includes(this.props.fieldName)) {
        return _react2.default.createElement(_components.IyvListTdShareclassNameTicker, {
          shareclass: this.props.shareclass,
          clickShareclass: this.props.clickShareclass
        });
      }

      if (['ussif'].includes(this.props.fieldName)) {
        return _react2.default.createElement(_components.IyvListTdSriUssif, {
          shareclass: this.props.shareclass,
          clickShareclass: this.props.clickShareclass
        });
      }

      if (['fund_net_assets'].includes(this.props.fieldName)) {
        return _react2.default.createElement(_components.IyvListTdNetAssets, {
          shareclass: this.props.shareclass,
          clickShareclass: this.props.clickShareclass
        });
      }

      if (['morningstar_category_name', 'category_group'].includes(this.props.fieldName)) {
        return _react2.default.createElement(_components.IyvListTdGroupCategory, {
          shareclass: this.props.shareclass,
          clickShareclass: this.props.clickShareclass
        });
      }

      if (['prospectus_net_expense_ratio', 'trailing_return_y1', 'trailing_return_y3', 'trailing_return_y5', 'trailing_return_y10', 'trailing_return_y15', 'trailing_return_y20'].includes(this.props.fieldName)) {
        return _react2.default.createElement(_components.IyvListTdReturns, {
          shareclass: this.props.shareclass,
          clickShareclass: this.props.clickShareclass,
          fieldName: this.props.fieldName
        });
      }

      if (['c2f5coogutweight'].includes(this.props.fieldName)) {
        return _react2.default.createElement(_components.IyvListTdFossilGrade, {
          shareclass: this.props.shareclass,
          clickShareclass: this.props.clickShareclass
        });
      }

      if (['gef_grp_norm'].includes(this.props.fieldName)) {
        return _react2.default.createElement(_components.IyvListTdGenderEqualityRank, {
          shareclass: this.props.shareclass,
          clickShareclass: this.props.clickShareclass,
          activeGrouping: this.props.activeGrouping
        });
      }

      if (['gef_score'].includes(this.props.fieldName)) {
        return _react2.default.createElement(_components.IyvListTdGenderEqualityScore, {
          shareclass: this.props.shareclass,
          clickShareclass: this.props.clickShareclass
        });
      }

      if (['fossil_bank_score', 'fossil_insure_score'].includes(this.props.fieldName)) {
        return _react2.default.createElement(_components.IyvListTdFossilFinanceGrade, {
          shareclass: this.props.shareclass,
          clickShareclass: this.props.clickShareclass,
          fieldName: this.props.fieldName
        });
      }

      if (['gm_weight', 'gr_weight', 'wff_civ_weight', 'pff_all_extreme_weight', 'pff_all_high_weight', 'pp_high_weight', 'borders_high_weight', 'pff_all_weight', 'cl_weight', 'po_producer_weight', 'po_financier_weight', 'po_consumer_weight', 'po_all_weight', 'mmc_weight', 'cm_weight', 'nw_weight', 'wff_mil_weight', 'to_weight', 'tm_weight', 't_all_weight'].includes(this.props.fieldName)) {
        return _react2.default.createElement(_components.IyvListTdPercent, {
          shareclass: this.props.shareclass,
          clickShareclass: this.props.clickShareclass,
          fieldName: this.props.fieldName
        });
      }

      if (['grade_guns', 'grade_prison_industrial_complex', 'grade_fossil', 'grade_deforestation', 'grade_gender_equality', 'grade_military', 'grade_tobacco'].includes(this.props.fieldName)) {
        return _react2.default.createElement(_components.IyvListTdGrade, {
          shareclass: this.props.shareclass,
          clickShareclass: this.props.clickShareclass,
          fieldName: this.props.fieldName
        });
      }

      return _react2.default.createElement(_components.IyvListTdDefault, {
        shareclass: this.props.shareclass,
        clickShareclass: this.props.clickShareclass,
        fieldName: this.props.fieldName
      });
    }
  }]);
  return IyvListTd;
}(_react.Component), _class10.propTypes = {
  shareclass: _react.PropTypes.object.isRequired,
  clickShareclass: _react.PropTypes.func.isRequired,
  fieldName: _react.PropTypes.string.isRequired,
  activeGrouping: _react.PropTypes.string
}, _temp5)) || _class9);
var IyvListTdCompareSelect = (_dec6 = (0, _reactCssModules2.default)(_IyvListTable2.default, { allowMultiple: true }), _dec6(_class11 = (_temp6 = _class12 = function (_Component6) {
  (0, _inherits3.default)(IyvListTdCompareSelect, _Component6);

  //
  function IyvListTdCompareSelect(props) {
    (0, _classCallCheck3.default)(this, IyvListTdCompareSelect);
    return (0, _possibleConstructorReturn3.default)(this, (IyvListTdCompareSelect.__proto__ || (0, _getPrototypeOf2.default)(IyvListTdCompareSelect)).call(this, props));
  }
  //


  (0, _createClass3.default)(IyvListTdCompareSelect, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'td',
        { styleName: 'col col-compare' },
        _react2.default.createElement(_components.IyvListCompareSelectIcon, {
          shareclass: this.props.shareclass,
          clickCompareSelect: this.props.clickCompareSelect,
          getCompareSelectStyles: this.props.getCompareSelectStyles,
          cart: this.props.cart
        })
      );
    }
  }]);
  return IyvListTdCompareSelect;
}(_react.Component), _class12.propTypes = {
  shareclass: _react.PropTypes.object.isRequired,
  clickCompareSelect: _react.PropTypes.func.isRequired,
  getCompareSelectStyles: _react.PropTypes.func.isRequired,
  cart: _react.PropTypes.object
}, _temp6)) || _class11);

/* @CSSModules(Styles, {allowMultiple:true})
class TdNumber extends Component {
  static propTypes = {
    shareclass: PropTypes.object.isRequired,
    clickShareclass: PropTypes.func.isRequired,
    fieldName: PropTypes.string.isRequired,
  }
  //
  constructor(props) {
    super(props)
  }
  //
  render() {
    return <td
      styleName='col-right'
      onClick={this.props.clickShareclass(this.props.shareclass)}
    >
      {format.number(this.props.shareclass[this.props.fieldName], true, true, 0)}
    </td>
  }
} */

/* @CSSModules(Styles, {allowMultiple:true})
class TdCarbonFootprint extends Component {
  static propTypes = {
    shareclass: PropTypes.object.isRequired,
    clickShareclass: PropTypes.func.isRequired,
    fieldName: PropTypes.string.isRequired,
  }
  //
  constructor(props) {
    super(props)
    //
    const getFootprintRange = (val) => {
      const { low, avg, high, veryHigh } = config.footprintRanges.footprint
      if (val <= low) {
        return 'low'
      } else if (val <= avg) {
        return 'below'
      } else if (val <= high) {
        return 'above'
      } else if (val <= veryHigh) {
        return 'high'
      } else {
        return 'extreme'
      }
    }

    this.state = {
      footprintRange = getFootprintRange(
        convert.float(props.shareclass.usd_relative_footprint)
      )
    }
  }
  //
  render() {
    if (
      this.props.shareclass.usd_relative_footprint &&
      convert.float(this.props.shareclass.usd_relative_footprint) !== 0.0
    ) {
      return (
        <td
          styleName='col'
          onClick={this.props.clickShareclass(this.props.shareclass, 'carbon-footprint')}
        >
          <span styleName={'footrange-' + this.state.footprintRange}>
            <LinkIcon faclass='fa-circle'/>
          </span>
          &nbsp;
          {format.number(this.props.shareclass.usd_relative_footprint,false)}
        </td>
      )
    } else {
      return (
        <td
          styleName='col'
          onClick={this.props.clickShareclass(this.props.shareclass)}
        >
          <small><em>Not avail.</em></small>
        </td>
      )
    }
  }
} */

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/core/IyvListTable/IyvListTable.js
// module id = 1326
// module chunks = 0